
<!-- Slideout PM metric selector section -->
<cv-module-custom-setting-section *ngIf="moduleManager.settingsView === 'slideout'" [moduleManager]="moduleManager" after="all">
    <div class="custom-setting-section-title">
        <div class="card-left">
            <div class="font-size-16 lato-bold" cvLocalizedText langSection="Slideout_Settings" langKey="Metrics">Metrics</div>
            <div class="body-2 mt-1">
                <span [hidden]="!settings.selectedMetricsText">{{ settings.selectedMetricsText }}</span>
                <span [hidden]="settings.selectedMetricsText" cvLocalizedText langSection="Slideout_Settings" langKey="No_Metrics_Chosen">No Metrics Chosen</span>
            </div>
        </div>
    </div>
    <div class="custom-setting-section-body">
        <div class="d-flex flex-nowrap align-items-start mt-2">
            <button type="button"
                class="btn btn-primary"
                (click)="openMetricSelector()"
                cvLocalizedText langSection="Current_Agent_States_Module" langKey="Metrics">Metrics</button>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="d-flex flex-wrap">
                    <div class="rounded-pill settings-hover-colors d-flex cursor-pointer mt-3 py-1 px-3 mr-2" *ngFor="let metric of settings.selectedMetrics" [attr.title]="metric.Name" style="height: 24px;">
                        <div class="flex-fill my-auto" style="line-height: 1rem;"><span>{{ getMetricDisplayName(metric) }}</span></div>
                        <svg [attr.id]="('module-' + stateKey + '-Settings-metric-' + metric.Abbreviation + '-' + metric.Id) | cleanId" class="icon-16 fill-valyrianSteel fill-hover-whaleTail my-auto ml-2" (click)="removeMetric(metric.Id)" style="height: 12px; width: 12px;">
                            <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</cv-module-custom-setting-section>